import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import ROLE_LEVEL from 'app/constants/RoleLevel';

import {
  routes,
  readOnlyRoutes,
  superAdminRoutes,
  mypakAdminGddRoutes,
  cacheRoutes,
} from './fuse-configs/routesConfig';

const AppContext = React.createContext({});

export function AppContextProvider(props) {
  const { children } = props;
  const {
    user: { data },
  } = useSelector((state) => state.auth);

  // Get pharmacy config to check read-only mode
  const pharmacyConfig = useSelector((state) => state.pharmacy?.update?.configuration?.data);
  const readOnlyMode = pharmacyConfig.readOnlyMode || false;

  // Method to select routes configuration
  const selectRoutesConfig = () => {
    if (data?.roleLevel === ROLE_LEVEL.SUPER_ADMIN) {
      return superAdminRoutes;
    }
    if (data?.roleLevel === ROLE_LEVEL.DRUG_ADMIN) {
      return mypakAdminGddRoutes;
    }
    if (readOnlyMode) {
      return readOnlyRoutes;
    }
    return routes;
  };

  return <AppContext.Provider value={{ routes: selectRoutesConfig(), cacheRoutes }}>{children}</AppContext.Provider>;
}

export default AppContext;
